import React, { useEffect, useState } from "react";
import humo from '../../images/humo.svg';
import uzcard from '../../images/uzcard.svg';
import plus from '../../images/plus.svg';
import card from '../../images/card.svg';
import buttonLoader from "../../images/button-loader.svg";
import './savedCards.css';
import AddCardForm from "./AddCardForm";
import axios from "axios";
import TypingAnimation from "../payment/TypingAnimation";
import { actions, getPaymentDetails, getPreloader } from "../redux/main-reducer";
import { useDispatch, useSelector } from "react-redux";
import { attachImageUrl } from "../../utils/attachImageUrl";

const OTP_LENGTH = 6;

const SavedCards = ({ 
  setCommonErrorMessage,
  savedCards, 
  showAllCards, 
  setShowAllCards, 
  showAddCardForm, 
  setShowAddCardForm,
  onCardSelect,
  selectedCard,
  onShowForm,
  isShowForm,
}) => {
  const API_ROOT = process.env.REACT_APP_API_ROOT;
  const paymentDetails = useSelector(getPaymentDetails);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [payID, setPayID] = useState("");
  const [smsVerificationState, setSmsVerificationState] = useState(false);
  const [otp, setOtp] = useState(Array(OTP_LENGTH).fill(""));
  const [errorMessageSMS, setErrorMessageSMS] = useState("");
  const [resendTimer, setResendTimer] = useState(59);
  const [isTimerActive, setIsTimerActive] = useState(false);
  const [isSmsRequired, setIsSmsRequired] = useState(false);
  const preloader = useSelector(getPreloader);

  const inputRefs = React.useRef([]);

  const dispatch = useDispatch();

  const searchParams = new URLSearchParams(window.location.search);
  const isInvType = searchParams.get("inv_type") === "4";

  useEffect(() => {
    let timer;
    if (isTimerActive && resendTimer > 0) {
      timer = setTimeout(() => {
        setResendTimer((prev) => prev - 1);
      }, 1000);
    } else if (resendTimer === 0) {
      setIsTimerActive(false);
    }
    return () => clearTimeout(timer);
  }, [resendTimer, isTimerActive]);

  const showSnackbar = (message) => {
    setSnackbarMessage(message);
    setSnackbarOpen(true);
    setTimeout(() => {
      setSnackbarOpen(false);
    }, 3000);
  };

  const handleCardSaved = () => {
    showSnackbar("Карта успешно сохранена!");
    // Закрываем форму после успешного сохранения
    setShowAddCardForm(false);
    onCardSelect(null);
  };

  const getCardType = (cardNumber) => {
    const firstFour = cardNumber.slice(0, 4);
    
    // Uzcard BINs (первые 4 цифры)
    const uzcardBins = ['8600', '6262', '5614', '5440'];
    
    // Humo BINs (первые 4 цифры)
    const humoBins = ['9860', '4073', '5555', '4728', '4097', '4008', '4067'];
    
    if (uzcardBins.includes(firstFour)) {
      return 'uzcard';
    }
    
    if (humoBins.includes(firstFour)) {
      return 'humo';
    }
    
    return 'card'; // значение по умолчанию для остальных карт
  };

  const getCardIcon = (cardType) => {
    switch (cardType) {
      case 'humo':
        return humo;
      case 'uzcard':
        return uzcard;
      default:
        return card;
    }
  };

  const getCardName = (cardType) => {
    switch (cardType) {
      case 'humo':
        return 'Humo';
      case 'uzcard':
        return 'Uzcard';
      default:
        return 'Карта';
    }
  };

  const handleCardClick = (card) => {
    onCardSelect(card);
  };

  const handleAddCard = () => {
    setShowAddCardForm(true);
  };

  const handleCancelAddCard = () => {
    setShowAddCardForm(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setCommonErrorMessage("");
    setIsSubmitting(true);
    console.log(selectedCard?.id);

    try {
      const key = new URLSearchParams(window.location.search).get("key");

      const data = {
        card_id: selectedCard.id,
        key: key,
        is_by_phone: false,
      };

      const response = await axios.post(
        `${API_ROOT}/api/v1/ecomm/payments/pay/create`,
        data
      );

      if (response.data && response.data.status === "Success") {
        const isSmsRequired = response?.data?.data?.is_sms_required;
        const payId = response?.data?.data?.pay_id;
        
        setIsSmsRequired(isSmsRequired);
        setPayID(payId);

        // Если SMS не требуется, сразу вызываем верификацию без OTP
        if (!isSmsRequired) {
          await handleVerification(null, false, payId); // Вызываем без OTP кода, isSmsRequired еще false
        } else {
          // Если SMS требуется, показываем форму верификации
          setSmsVerificationState(true);
          onShowForm(true);
          setResendTimer(59);
          setIsTimerActive(true);
        }
      } else {
        throw new Error(
          response.data.error_note || "Не удалось инициировать оплату"
        );
      }
    } catch (error) {
      console.error("Error during payment request:", error);
      setCommonErrorMessage(error?.response?.data?.error_note || "Произошла ошибка. Пожалуйста, попробуйте позже");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleVerification = async (otpCode, isSmsRequiredParam = isSmsRequired, payIdParam = payID) => {
    // Валидация OTP только если он требуется
    if (isSmsRequiredParam && (!otpCode || !/^[a-zA-Z0-9]{6}$/.test(otpCode))) {
      console.warn("OTP невалиден");
      return;
    }

    // e.preventDefault();
    setErrorMessageSMS("");
    setCommonErrorMessage("");

    try {
      dispatch(actions.setPreloader(true));

         // Формируем data в зависимости от isSmsRequired
      const data = isSmsRequiredParam 
        ? {
            confirm_code: otpCode,
            pay_id: payID,
          }
        : {
            pay_id: payIdParam,
          };

      const response = await axios.post(
        `${API_ROOT}/api/v1/ecomm/payments/pay/confirm`,
        data
      );

      console.log("SMS Verification Success:", response);

      if (response.data && response.data.status === "Success") {
        dispatch(actions.setPaymentDetails(attachImageUrl(response?.data?.data)));
        console.log(response?.data?.data);
        // window.location.replace(`${paymentDetails?.success_url}`);
        setTimeout(() => {
          dispatch(actions.setPaymentState(true));
          dispatch(actions.setPreloader(false));
          dispatch(actions.setPaymentDetails(attachImageUrl(response?.data?.data)));
          setIsSmsRequired(false);
        }, 1000);
      } else {
        throw new Error(
          response.data.error_note || "Не удалось подтвердить оплату"
        );
      }
    } catch (error) {
      console.error("Error during SMS verification:", error);
      if (error.response?.data?.error_code === 1008) {
        setErrorMessageSMS("Введенный SMS-код не верный");
      } else if (error.response?.data?.error_code === 1027) {
        setErrorMessageSMS(
          "Карта заблокирована. Попробуйте снова через 5 минут"
        );
      } else if (error.response?.data?.error_code === 1028) {
        setErrorMessageSMS(
          "Карта заблокирована. Попробуйте снова через 5 минут"
        );
      } else if (error.response?.data?.error_code === 1029) {
        setErrorMessageSMS(
          "Повторно запросить SMS-код можно только через 1 минуту."
        );
      } else if (error.response?.data?.error_code === 1030) {
        setErrorMessageSMS(
          "Срок действия кода подтверждения платежа истёк. Код действителен в течение 1 минуты"
        );
      } else if (error.response?.data?.error_code === 1031) {
        setErrorMessageSMS("Время повторной отправки SMS истекло.");
      } else if (error.response?.data?.error_code === 1004) {
        setErrorMessageSMS(
          "Функция отправки SMS-кода не работает. Пожалуйста попробуйте позже"
        );
      } else if (error.response?.data?.error_code === 1058) {
        setErrorMessageSMS(
          "SMS уже было отправлено. Пожалуйста, попробуйте снова через 1 минуту."
        );
      } else if (isInvType) {
        window.location.replace(`${paymentDetails?.failure_url}`);
        setErrorMessageSMS("Ошибка проверки SMS-кода");
      } else {
        setErrorMessageSMS("Ошибка проверки SMS-кода");
      }
      dispatch(actions.setPreloader(false));
    }
  };

  const handleResend = async () => {
    setErrorMessageSMS("");
    setCommonErrorMessage("");
    setResendTimer(59);
    setIsTimerActive(true);

    try {
      const data = {
        pay_id: payID,
      };

      const response = await axios.post(
        `${API_ROOT}/api/v1/ecomm/payments/pay/sms/resend`,
        data
      );

      console.log("SMS Resend Response:", response);

      if (response.data && response.data.status === "Success") {
        console.log("SMS code resent successfully");
      } else {
        throw new Error(
          response.data.error_note || "Не удалось повторно отправить код"
        );
      }
    } catch (error) {
      console.error("Error during SMS resend:", error);
      if (error.response?.data?.error_code === 1031) {
        setErrorMessageSMS("Время ожидания отправки SMS-кода истекло");
      } else {
        setErrorMessageSMS(error.message || "Ошибка повторной отправки СМС-кода");
      }
      setIsTimerActive(false);
    }
  };

  const handleChange = (e, index) => {
    const value = e.target.value.replace(/[^a-zA-Z0-9]/g, "");
    if (!value) return;

    const newOtp = [...otp];
    newOtp[index] = value[0]; // Вставляем только первую цифру
    setOtp(newOtp);

    // Перейти к следующему полю
    if (index < OTP_LENGTH - 1) {
      inputRefs.current[index + 1]?.focus();
    }

    // Отправка только когда все 6 полей заполнены
    const otpComplete = newOtp.every((val) => val.length === 1);
    if (otpComplete) {
      const otpCode = newOtp.join("");
      handleVerification(otpCode);
    }
  };

  const handlePaste = (e) => {
    const pasteData = e.clipboardData
      .getData("Text")
      .replace(/[^a-zA-Z0-9]/g, "");

    if (pasteData.length === OTP_LENGTH) {
      const newOtp = pasteData.split("").slice(0, OTP_LENGTH);
      setOtp(newOtp);

      // автофокус на последнем
      inputRefs.current[OTP_LENGTH - 1]?.focus();

      // автоотправка
      handleVerification(newOtp.join(""));
    }

    e.preventDefault(); // предотвратить вставку в одно поле
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      const newOtp = [...otp];
      if (otp[index]) {
        newOtp[index] = "";
        setOtp(newOtp);
      } else if (index > 0) {
        inputRefs.current[index - 1]?.focus();
      }
    }
  };

  return (
    <div className="saved-cards">
      <div className="saved-cards__list">
        {savedCards && savedCards.slice(0, showAllCards ? savedCards.length : 1).map((card) => {
          const cardType = getCardType(card.masked_pan);
          const cardIcon = getCardIcon(cardType);
          const cardName = getCardName(cardType);
          
          return (
            <div
              key={card.id}
              className={`saved-cards__item ${selectedCard?.id === card.id ? 'saved-cards__item_active' : ''}`}
              onClick={() => handleCardClick(card)}
            >
              <div className="saved-cards__item-left">
                <img src={cardIcon} alt={cardName} className="saved-cards__item-icon" />
              </div>
              <div className="saved-cards__item-right">
                <div className="saved-cards__item-name">{cardName}</div>
                <div className="saved-cards__item-number">{card.masked_pan}</div>
              </div>
            </div>
          );
        })}
      </div>

      {savedCards && savedCards.length > 1 && (
        <button 
          className="saved-cards__toggle"
          onClick={() => setShowAllCards(!showAllCards)}
        >
          {showAllCards ? 'Скрыть' : 'Показать все сохранённые карты'}
        </button>
      )}

      {!showAddCardForm && (
        <button className="saved-cards__add-button" onClick={handleAddCard}>
          <div className="saved-cards__add-button-left">
            <div className="saved-cards__add-button-icon">
              <img src={plus} alt="Добавить" />
            </div>
          </div>
          <div className="saved-cards__add-button-text">Добавить карту для сохранения</div>
        </button>
      )}

      {showAddCardForm && (
        <AddCardForm
          onCancel={handleCancelAddCard}
          onCardSaved={handleCardSaved}
          setCommonErrorMessage={setCommonErrorMessage}
        />
      )}

      {selectedCard && (
        <button
          className={`pay-button ${isSubmitting ? "_disable" : ""}`}
          disabled={isSubmitting}
          onClick={handleSubmit}
        >
          {isSubmitting ? (
            <div className="button-loader">
              <img
                className="button-loader__image"
                src={buttonLoader}
                alt=""
              />
            </div>
          ) : (
            "Оплатить сохранённой картой"
          )}
        </button>
      )}
      {isSmsRequired && smsVerificationState && isShowForm && (
        <div className={`payment-container-info ${preloader ? "blur" : ""}`}>  
            <div className="otp-wrapper">
              <div className="otp-wrapper__block">
                {otp.map((digit, index) => (
                  <input
                    key={index}
                    type="text"
                    inputMode="numeric"
                    maxLength={1}
                    className={`otp-input ${
                      errorMessageSMS && "otp-input_error"
                    }`}
                    value={digit}
                    onChange={(e) => handleChange(e, index)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    onPaste={handlePaste}
                    ref={(el) => {
                      if (el) inputRefs.current[index] = el;
                    }}
                  />
                ))}
              </div>
              {errorMessageSMS && (
                <div className="error-message">{errorMessageSMS}</div>
              )}
            </div>
            {isTimerActive ? (
              <div className="resend-sms">
                Отправим код повторно через{" "}
                {resendTimer.toString().padStart(2, "0")} секунд
              </div>
            ) : (
              <div className="resend-sms" onClick={handleResend}>
                Отправить СМС повторно
              </div>
            )}
        </div>
      )}
      {preloader && (
        <div className="loader">
          <div className="loading"></div>
          <div className="typing-container">
            <TypingAnimation
              texts={["Идёт оплата...", "Не закрывайте страницу..."]}
              typingInterval={70}
              pauseDuration={1000}
            />
          </div>
        </div>
      )}

      {snackbarOpen && (
        <div className="snackbar">
          {snackbarMessage}
        </div>
      )}
    </div>
  );
};

export default SavedCards;
